module.exports = __webpack_public_path__ + "static/media/chatbot-icon.cd0c08ef.svg";